import {useQueryClient} from '@tanstack/react-query';
import {Box} from '@mantine/core';
import {ReloadButton} from '@flexinet/ui-components';

import {subscriptionsKeys} from '../hooks/useSubscriptionsQuery';

/**
 * FNP-918: reload now INVALIDATES the list key rather than calling
 * `fetchRecords`.
 *
 * Under the infinite query `fetchRecords` means "fetch the NEXT page" — so
 * wiring Reload to it would have appended a page instead of refreshing, which
 * is the opposite of what the control says it does. Invalidating drops the
 * accumulated pages and refetches from the first one.
 *
 * It goes through the query client rather than `useSubscriptions().reload` so
 * this button does not instantiate a second copy of the whole list hook just to
 * get at one callback — which is what it did before, mounting a duplicate query
 * in the page header.
 */
export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    return (
        <Box mx='s'>
            <ReloadButton
                onClick={() => queryClient.invalidateQueries({
                    queryKey: subscriptionsKeys.lists(),
                })}
            />
        </Box>
    );
};
